import axios from "axios";

export default {
  namespaced: true,
  state: {
    teamRecords: null
  },
  mutations: {
    setTeamRecords(state, data) {
      state.teamRecords = data;
    }
  },
  actions: {
    async fetchTeamRecords({ state, commit }) {
      if (state.teamRecords) return state.teamRecords;
      const response = await axios.get("/api/games/leaders/getTop10Teams");
      commit("setTeamRecords", response.data);
      return response.data;
    }
  }
}